export default {
    data() {
        return {
          errors: {},
        }
    },
    created() {
        this.errors = this.makeErrorStack()
    },
    methods: {
        makeErrorStack() {
            let errors = {}

            for (let i in this.ErrorKeys) {
                let key;

                if (typeof this.ErrorKeys[i] === 'object') {
                    key = this.ErrorKeys[i].key
                } else {
                    key = this.ErrorKeys[i]
                }

                errors[key] = {
                    isInvalid: false,
                    errors: [],
                    firstError: ''
                }
            }

            return errors
        },
        transformErrorsFromRequest(e) {
            let errors = this.makeErrorStack()

            for (let i in e.response.data.errors) {
                for (let j in this.ErrorKeys) {
                    let errorKey = this.ErrorKeys[j]
                    if (typeof errorKey === 'string' && i === errorKey) {
                        errors[i].errors = e.response.data.errors[i]
                        errors[i].isInvalid = true
                        errors[i].firstError =  e.response.data.errors[i][0]
                    } else if (errorKey.composition && errorKey.composition.indexOf(i) > -1) {
                        errors[errorKey.key].errors = _.merge(errors[errorKey.key].errors, e.response.data.errors[i])
                        errors[errorKey.key].isInvalid = true
                        errors[errorKey.key].firstError =  this.errors[errorKey.key].errors[0]
                    }
                }
            }

            return errors
        },
        handleHttpException(e, merge = true) {
            if (e.response.status === 422) {
                if (merge) {
                    let errors = this.transformErrorsFromRequest(e)

                    for (let i in this.errors) {
                        if (errors[i]) {
                            this.errors[i].errors = _.merge(this.errors[i].errors, errors[i].errors)
                            if (this.errors[i].isInvalid || errors[i].errors.length > 0) {
                                this.errors[i].isInvalid = true
                                this.errors[i].firstError = this.errors[i].errors[0]
                            }
                        }
                    }
                } else {
                    this.errors = this.transformErrorsFromRequest(e)
                }
            } else {
                handleApiError(e)
            }

            this.$emit('error', e)
        }
    }
}